import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  class: "modal-body",
  style: {"min-height":"300px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "lead" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_11 = {
  class: "form-inline my-2 my-lg-0 ml-auto",
  role: "search"
}
const _hoisted_12 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = {
  class: "btn btn-sm btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_15 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "table" }
const _hoisted_18 = { class: "fg-color-gray mb-0 mt-1" }
const _hoisted_19 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_20 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_21 = {
  key: 0,
  style: {"width":"80px"}
}
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = {
  key: 1,
  style: {"width":"80px"}
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = {
  class: "btn btn-outline-secondary",
  target: "_blank"
}

import { ref, computed } from 'vue'
    import { useRoute } from 'vue-router'

    import { strCompare, isNullOrWhitespace } from '@common/Common'
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    import type { PanelistReadModel } from '@Evaluation/Estimations/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistsSelector',
  props: {
    Visible: { type: Boolean },
    WorkspaceId: {},
    ProjectId: {},
    TargetingEnabled: { type: Boolean },
    Tags: {},
    Panelists: {}
  },
  emits: ["excludePanelist", "includePanelist", "showPanelistAlternativesSelector", "close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- local UI state ----------------

    const tag = ref<string | null>(null)
    const searchPhrase = ref<string | null>(null)

    // ---------------- derived ----------------

    const workspaceId = computed(() => props.WorkspaceId)
    const tchProjectId = computed(() => props.ProjectId)

    const panelistsView = computed<PanelistReadModel[]>(() =>
    {
        let view = props.Panelists.filter(p => p.IsArchived === false)

        if (!isNullOrWhitespace(searchPhrase.value))
        {
            const phrase = searchPhrase.value!.toLowerCase()
            view = view.filter(p =>
                (`${p.Name} ${p.Email}`).toLowerCase().includes(phrase)
            )
        }

        if (tag.value)
        {
            view = view.filter(p => p.Tags.includes(tag.value!))
        }

        return view
            .slice()
            .sort((a, b) =>
                strCompare(a.Name.toLowerCase(), b.Name.toLowerCase())
            )
    })

    const tagLabel = computed(() =>
    {
        if (!isNullOrWhitespace(tag.value))
            return tag.value!

        return 'Show all'
    })

    const url_PeoplePage = computed(() =>
        dynamicUiRoutes.ProjectUsers_PeoplePage(
            route,
            workspaceId.value,
            tchProjectId.value
        )
    )

    // ---------------- actions ----------------

    function selectTag(t: string | null)
    {
        tag.value = t
    }

    function excludePanelist(projectUserId: number)
    {
        emit('excludePanelist', projectUserId)
    }

    function includePanelist(projectUserId: number)
    {
        emit('includePanelist', projectUserId)
    }

    function showPanelistAlternativesSelector(projectUserId: number)
    {
        emit('showPanelistAlternativesSelector', projectUserId)
    }

    function close()
    {
        emit('close')
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Add panelists", -1 /* CACHED */)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              onClick: close
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_5, [
            (__props.Panelists.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createTextVNode(" You currently have no Respondents set-up in the software. Please go to the ", -1 /* CACHED */)),
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("People section", -1 /* CACHED */)
                    ]))])), [
                      [_directive_sanitizedHref, url_PeoplePage.value]
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode(" to upload names & emails. ", -1 /* CACHED */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (__props.Panelists.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("nav", _hoisted_10, [
                    _createElementVNode("form", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm mr-sm-2",
                        type: "search",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, searchPhrase.value]
                      ])
                    ]),
                    _createElementVNode("form", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", _hoisted_14, [
                          _createElementVNode("span", null, "Filter by: " + _toDisplayString(tagLabel.value), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectTag(null)))
                          }, "Show all"),
                          _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "dropdown-header" }, "By tag:", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.Tags, (t) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (selectTag(t))
                            }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_16))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panelistsView.value, (p) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: p.ProjectUserId
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_18, [
                              _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */)
                            ]),
                            (p.HasEmail)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(p.Email), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (!p.HasEmail)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_20, "Email not provided"))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Tags, (t) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "badge badge-secondary mr-1",
                                key: t
                              }, _toDisplayString(t), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          (__props.TargetingEnabled)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-outline-secondary",
                                  onClick: ($event: any) => (showPanelistAlternativesSelector(p.ProjectUserId)),
                                  disabled: !p.HasEmail
                                }, _toDisplayString(p.IsIncluded ? "Added" : "Add"), 9 /* TEXT, PROPS */, _hoisted_22)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (!__props.TargetingEnabled)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                (p.IsIncluded)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-outline-danger",
                                      onClick: ($event: any) => (excludePanelist(p.ProjectUserId))
                                    }, "Exclude", 8 /* PROPS */, _hoisted_24))
                                  : _createCommentVNode("v-if", true),
                                (!p.IsIncluded)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-outline-success",
                                      onClick: ($event: any) => (includePanelist(p.ProjectUserId))
                                    }, "Include", 8 /* PROPS */, _hoisted_25))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_27, [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Add people", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, url_PeoplePage.value]
            ]),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "btn btn-outline-secondary"
            }, "Close")
          ])
        ])
      ])
    ])
  ], 512 /* NEED_PATCH */)), [
    [_vShow, __props.Visible]
  ])
}
}

})